import { render, staticRenderFns } from "./AppIconTooltip.vue?vue&type=template&id=d89453b8"
import script from "./AppIconTooltip.vue?vue&type=script&lang=js"
export * from "./AppIconTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports